/* tslint:disable */
/* eslint-disable */
/**
 * Happyforce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CheckDomainResponse } from '../models';
// @ts-ignore
import type { CompanyAccountStatus } from '../models';
// @ts-ignore
import type { CompanyConfig } from '../models';
// @ts-ignore
import type { CompanyCustomizationDTO } from '../models';
// @ts-ignore
import type { CompanyDTO } from '../models';
// @ts-ignore
import type { CompanySetupRequestDTO } from '../models';
/**
 * CompanyConfigResourceApi - axios parameter creator
 * @export
 */
export const CompanyConfigResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDomain: async (domain: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('checkDomain', 'domain', domain)
            const localVarPath = `/api/v1/company/config/domain/{domain}`
                .replace(`{${"domain"}}`, encodeURIComponent(String(domain)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyConfig: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyConfig', 'companyId', companyId)
            const localVarPath = `/api/v1/company/config/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCompanyConfigStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/config/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyCurrentCompanyConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyCustomization: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/config/customization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompanySetupRequestDTO} companySetupRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupCompany: async (companySetupRequestDTO: CompanySetupRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companySetupRequestDTO' is not null or undefined
            assertParamExists('setupCompany', 'companySetupRequestDTO', companySetupRequestDTO)
            const localVarPath = `/api/v1/company/config/setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companySetupRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompanyDTO} companyDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany: async (companyDTO: CompanyDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyDTO' is not null or undefined
            assertParamExists('updateCompany', 'companyDTO', companyDTO)
            const localVarPath = `/api/v1/company/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CompanyAccountStatus} accountStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyAccountStatus: async (companyId: string, accountStatus: CompanyAccountStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('updateCompanyAccountStatus', 'companyId', companyId)
            // verify required parameter 'accountStatus' is not null or undefined
            assertParamExists('updateCompanyAccountStatus', 'accountStatus', accountStatus)
            const localVarPath = `/api/v1/company/config/{companyId}/{accountStatus}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"accountStatus"}}`, encodeURIComponent(String(accountStatus)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CompanyConfig} companyConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyConfig: async (companyId: string, companyConfig: CompanyConfig, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('updateCompanyConfig', 'companyId', companyId)
            // verify required parameter 'companyConfig' is not null or undefined
            assertParamExists('updateCompanyConfig', 'companyConfig', companyConfig)
            const localVarPath = `/api/v1/company/config/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompanyCustomizationDTO} companyCustomizationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyCustomization: async (companyCustomizationDTO: CompanyCustomizationDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyCustomizationDTO' is not null or undefined
            assertParamExists('updateCompanyCustomization', 'companyCustomizationDTO', companyCustomizationDTO)
            const localVarPath = `/api/v1/company/config/customization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyCustomizationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCompanyImage: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadCompanyImage', 'file', file)
            const localVarPath = `/api/v1/company/config/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyConfigResourceApi - functional programming interface
 * @export
 */
export const CompanyConfigResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyConfigResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkDomain(domain: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckDomainResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkDomain(domain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyConfigResourceApi.checkDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyConfig(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyConfig(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyConfigResourceApi.getCompanyConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getCompanyConfigStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyConfigStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyConfigResourceApi.getCompanyConfigStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyCurrentCompanyConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyCurrentCompanyConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyConfigResourceApi.getCompanyCurrentCompanyConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyCustomization(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyCustomizationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyCustomization(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyConfigResourceApi.getCompanyCustomization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CompanySetupRequestDTO} companySetupRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setupCompany(companySetupRequestDTO: CompanySetupRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setupCompany(companySetupRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyConfigResourceApi.setupCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CompanyDTO} companyDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompany(companyDTO: CompanyDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompany(companyDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyConfigResourceApi.updateCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CompanyAccountStatus} accountStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompanyAccountStatus(companyId: string, accountStatus: CompanyAccountStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompanyAccountStatus(companyId, accountStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyConfigResourceApi.updateCompanyAccountStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CompanyConfig} companyConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompanyConfig(companyId: string, companyConfig: CompanyConfig, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompanyConfig(companyId, companyConfig, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyConfigResourceApi.updateCompanyConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CompanyCustomizationDTO} companyCustomizationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompanyCustomization(companyCustomizationDTO: CompanyCustomizationDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyCustomizationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompanyCustomization(companyCustomizationDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyConfigResourceApi.updateCompanyCustomization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCompanyImage(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCompanyImage(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyConfigResourceApi.uploadCompanyImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompanyConfigResourceApi - factory interface
 * @export
 */
export const CompanyConfigResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyConfigResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDomain(domain: string, options?: RawAxiosRequestConfig): AxiosPromise<CheckDomainResponse> {
            return localVarFp.checkDomain(domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyConfig(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyConfig> {
            return localVarFp.getCompanyConfig(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCompanyConfigStatus(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getCompanyConfigStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyCurrentCompanyConfig(options?: RawAxiosRequestConfig): AxiosPromise<CompanyConfig> {
            return localVarFp.getCompanyCurrentCompanyConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyCustomization(options?: RawAxiosRequestConfig): AxiosPromise<CompanyCustomizationDTO> {
            return localVarFp.getCompanyCustomization(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanySetupRequestDTO} companySetupRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupCompany(companySetupRequestDTO: CompanySetupRequestDTO, options?: RawAxiosRequestConfig): AxiosPromise<CompanyDTO> {
            return localVarFp.setupCompany(companySetupRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyDTO} companyDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany(companyDTO: CompanyDTO, options?: RawAxiosRequestConfig): AxiosPromise<CompanyDTO> {
            return localVarFp.updateCompany(companyDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CompanyAccountStatus} accountStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyAccountStatus(companyId: string, accountStatus: CompanyAccountStatus, options?: RawAxiosRequestConfig): AxiosPromise<CompanyConfig> {
            return localVarFp.updateCompanyAccountStatus(companyId, accountStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CompanyConfig} companyConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyConfig(companyId: string, companyConfig: CompanyConfig, options?: RawAxiosRequestConfig): AxiosPromise<CompanyConfig> {
            return localVarFp.updateCompanyConfig(companyId, companyConfig, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyCustomizationDTO} companyCustomizationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyCustomization(companyCustomizationDTO: CompanyCustomizationDTO, options?: RawAxiosRequestConfig): AxiosPromise<CompanyCustomizationDTO> {
            return localVarFp.updateCompanyCustomization(companyCustomizationDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCompanyImage(file: File, options?: RawAxiosRequestConfig): AxiosPromise<CompanyDTO> {
            return localVarFp.uploadCompanyImage(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyConfigResourceApi - object-oriented interface
 * @export
 * @class CompanyConfigResourceApi
 * @extends {BaseAPI}
 */
export class CompanyConfigResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} domain 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyConfigResourceApi
     */
    public checkDomain(domain: string, options?: RawAxiosRequestConfig) {
        return CompanyConfigResourceApiFp(this.configuration).checkDomain(domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyConfigResourceApi
     */
    public getCompanyConfig(companyId: string, options?: RawAxiosRequestConfig) {
        return CompanyConfigResourceApiFp(this.configuration).getCompanyConfig(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CompanyConfigResourceApi
     */
    public getCompanyConfigStatus(options?: RawAxiosRequestConfig) {
        return CompanyConfigResourceApiFp(this.configuration).getCompanyConfigStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyConfigResourceApi
     */
    public getCompanyCurrentCompanyConfig(options?: RawAxiosRequestConfig) {
        return CompanyConfigResourceApiFp(this.configuration).getCompanyCurrentCompanyConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyConfigResourceApi
     */
    public getCompanyCustomization(options?: RawAxiosRequestConfig) {
        return CompanyConfigResourceApiFp(this.configuration).getCompanyCustomization(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanySetupRequestDTO} companySetupRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyConfigResourceApi
     */
    public setupCompany(companySetupRequestDTO: CompanySetupRequestDTO, options?: RawAxiosRequestConfig) {
        return CompanyConfigResourceApiFp(this.configuration).setupCompany(companySetupRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyDTO} companyDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyConfigResourceApi
     */
    public updateCompany(companyDTO: CompanyDTO, options?: RawAxiosRequestConfig) {
        return CompanyConfigResourceApiFp(this.configuration).updateCompany(companyDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {CompanyAccountStatus} accountStatus 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyConfigResourceApi
     */
    public updateCompanyAccountStatus(companyId: string, accountStatus: CompanyAccountStatus, options?: RawAxiosRequestConfig) {
        return CompanyConfigResourceApiFp(this.configuration).updateCompanyAccountStatus(companyId, accountStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {CompanyConfig} companyConfig 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyConfigResourceApi
     */
    public updateCompanyConfig(companyId: string, companyConfig: CompanyConfig, options?: RawAxiosRequestConfig) {
        return CompanyConfigResourceApiFp(this.configuration).updateCompanyConfig(companyId, companyConfig, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyCustomizationDTO} companyCustomizationDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyConfigResourceApi
     */
    public updateCompanyCustomization(companyCustomizationDTO: CompanyCustomizationDTO, options?: RawAxiosRequestConfig) {
        return CompanyConfigResourceApiFp(this.configuration).updateCompanyCustomization(companyCustomizationDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyConfigResourceApi
     */
    public uploadCompanyImage(file: File, options?: RawAxiosRequestConfig) {
        return CompanyConfigResourceApiFp(this.configuration).uploadCompanyImage(file, options).then((request) => request(this.axios, this.basePath));
    }
}

